// import { AlertColor } from "@mui/material"

// export type SnackbarState = {
//     severity: AlertColor;
//     message: string;
// }

export type StorageImage = {
    fileName: string;
    token: string;
}

export type MemoryState = {
    // loading: number;
    // snackbar: SnackbarState;
    images: StorageImage[]
}

export const INITIAL_STATE: MemoryState = {
    // loading: 0,
    // snackbar: {
    //     severity: 'success',
    //     message: ''
    // },
    images: [
        { fileName: 'memory_001.JPG', token: '0531b03b-264c-4bb6-b7d5-45fee7c8db51' },
        { fileName: 'memory_002.JPG', token: 'daa7d229-b202-45c2-852f-30227db46c5a' },
        { fileName: 'memory_003.JPG', token: '609294c1-75b3-454a-800a-be56e50c43ed' },
        { fileName: 'memory_004.JPG', token: '12816648-7bd2-483c-9b86-4910033df775' },
        { fileName: 'memory_005.JPG', token: 'd135a05c-1c73-4972-b32d-ddd6a81c4b1e' },
    ]
}
